const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;

const request = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}/${endpoint}`;
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (options.body instanceof FormData) {
    delete headers['Content-Type'];
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    headers,
    ...options,
  };

  const response = await fetch(url, config);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'An unknown error occurred' }));
    throw new Error(errorData.message || 'Something went wrong');
  }
  if (response.status === 204) {
    return;
  }
  return response.json();
};

// ... (keep existing exports)



// Recipes
export const getRecipes = () => request('recipes');
export const findRecipesByIngredients = (ingredients) => request(`recipes?ingredients=${ingredients}`);
export const addRecipeAPI = (recipe) => request('recipes', { method: 'POST', body: JSON.stringify(recipe) });
export const updateRecipeAPI = (id, recipe) => request(`recipes/${id}`, { method: 'PUT', body: JSON.stringify(recipe) });
export const deleteRecipeAPI = (id) => request(`recipes/${id}`, { method: 'DELETE' });

// Cookbooks
export const getCookbooks = () => request('cookbooks');
export const addCookbookAPI = (cookbook) => request('cookbooks', { method: 'POST', body: JSON.stringify(cookbook) });
export const updateCookbookAPI = (id, cookbook) => request(`cookbooks/${id}`, { method: 'PUT', body: JSON.stringify(cookbook) });
export const deleteCookbookAPI = (id) => request(`cookbooks/${id}`, { method: 'DELETE' });

// Categories
export const getCategories = () => request('categories');
export const addCategoryAPI = (category) => request('categories', { method: 'POST', body: JSON.stringify(category) });
export const updateCategoryAPI = (id, category) => request(`categories/${id}`, { method: 'PUT', body: JSON.stringify(category) });
export const deleteCategoryAPI = (id) => request(`categories/${id}`, { method: 'DELETE' });

// Ingredients
export const getIngredients = () => request('ingredients');
export const addIngredientAPI = (ingredient) => request('ingredients', { method: 'POST', body: JSON.stringify(ingredient) });
export const updateIngredientAPI = (id, ingredient) => request(`ingredients/${id}`, { method: 'PUT', body: JSON.stringify(ingredient) });
export const deleteIngredientAPI = (id) => request(`ingredients/${id}`, { method: 'DELETE' });

// Additional Item Groups
export const getAdditionalItemGroups = () => request('additional-item-groups');
export const addAdditionalItemGroupAPI = (group) => request('additional-item-groups', { method: 'POST', body: JSON.stringify(group) });
export const updateAdditionalItemGroupAPI = (id, group) => request(`additional-item-groups/${id}`, { method: 'PUT', body: JSON.stringify(group) });
export const deleteAdditionalItemGroupAPI = (id) => request(`additional-item-groups/${id}`, { method: 'DELETE' });

// Meal Plans
export const getMealplans = () => request('mealplans');
export const getMealplanIngredients = (mealPlan) => request('mealplans/ingredients', { method: 'POST', body: JSON.stringify(mealPlan) });
export const addMealplanAPI = (mealPlan) => request('mealplans', { method: 'POST', body: JSON.stringify(mealPlan) });
export const updateMealplanAPI = (id, mealPlan) => request(`mealplans/${id}`, { method: 'PUT', body: JSON.stringify(mealPlan) });
export const deleteMealplanAPI = (id) => request(`mealplans/${id}`, { method: 'DELETE' });
export const getAutoSavedMealPlan = () => request('mealplans/autosave');
export const autoSaveMealPlan = (mealPlan) => request('mealplans/autosave', { method: 'POST', body: JSON.stringify(mealPlan) });
export const clearAutoSavedMealPlan = () => request('mealplans/autosave', { method: 'DELETE' });

// FAQs
export const getFaqs = () => request('faqs');

// Users
export const login = (username, password, rememberMe) => request('users/login', { method: 'POST', body: JSON.stringify({ username, password, rememberMe }) });
export const register = (username, password) => request('users/register', { method: 'POST', body: JSON.stringify({ username, password }) });
export const getUser = () => request('users/profile');
export const updateUser = (data) => request('users/profile', { method: 'PUT', body: JSON.stringify(data) });
export const changePassword = (data) => request('users/password', { method: 'PUT', body: JSON.stringify(data) });
export const refreshTokenAPI = () => request('users/refresh-token', { method: 'POST' });

// OCR
// OCR
export const ocrImage = async (imageBlob, type = 'cookbook-title') => {
  const formData = new FormData();
  formData.append('image', imageBlob);
  formData.append('type', type);

  return request('ocr', {
    method: 'POST',
    body: formData,
  });
};
